import { render, staticRenderFns } from "./UserEditPass.vue?vue&type=template&id=e64d8034&scoped=true"
import script from "./UserEditPass.vue?vue&type=script&lang=js"
export * from "./UserEditPass.vue?vue&type=script&lang=js"
import style0 from "./UserEditPass.vue?vue&type=style&index=0&id=e64d8034&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e64d8034",
  null
  
)

export default component.exports